import { Component, computed, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { CommonService } from 'src/app/trip-view/services/common.service';
import { ToastService } from 'mis-crystal-design-system/toast';
import * as dayjs from 'dayjs';
import { DataService } from 'src/app/data.service';
import { ATTENDANCE_ACTIONS, AttendanceAction } from 'src/app/utils/constants';

@Component({
  selector: 'app-employee-card',
  templateUrl: './employee-card.component.html',
  styleUrls: ['./employee-card.component.scss']
})
export class EmployeeCardComponent implements OnInit {
  imgSrc: string;
  constructor(private envService: EnvironmentService, private commonService: CommonService,private toast:ToastService,private dataService:DataService) 
  { 
    this.employees = [];
  }
  @Input() employees: any[];
  @Input() activeBg:boolean=false;
  @Output() openEmployee=new EventEmitter<any>();
  response:any;
  isAllowSignoutEmployeesOnTripView=computed(()=>this.dataService.isAllowSignoutEmployeesOnTripView());
  AttendanceAction=AttendanceAction;
  isTripCompleted=signal<boolean>(false);
  ngOnInit(): void {
    this.imgSrc = this.envService.getImgSrc();
   this.response=this.commonService.response;
   this.isTripCompleted.set(this.response?.['tripDetails']?.['status']?.toLowerCase() === 'ended');
    console.log("employees array",this.employees);
    
  }
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const timeString = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return timeString;
  }

  openEmployeeDetails(value){
    console.log('employee',value);
    
    this.openEmployee.emit(value);
  }

  isSignedIn(emp: any): boolean {
    const tripStatus = this.response['tripDetails']['status'];
    return !!emp['actualPickupTime']  && !emp['actualDropTime'] && tripStatus !== 'Ended';
  }
  updateAttendance(emp: any,action:AttendanceAction): void {
    const tripId = this.commonService.tripId;
    const actionConfig=ATTENDANCE_ACTIONS[action];
    const payload={
      buid:this.commonService.buid,
      employeeGuid:emp.empGuid,
      eventTimestamp: dayjs().valueOf(),
      locationTimestamp:dayjs().valueOf(),
      employeeAppAttendanceSource:"TRIP_CARD_BUTTON",
      employeeAppAttendanceEventType:action,
      vehicleGuid:this.response?.['tripDetails']?.['vehicle']?.['vehicleGuid'],
      tripId:tripId,
      isSignedOff:actionConfig.isSignedOff
    }
    
    this.commonService.updateAttendance(payload).subscribe({
      next: (response) => {
        this.toast.displayMsg(`Employee ${emp?.name} ${actionConfig.successText} Successfully !`);
        setTimeout(() => {
         window.location.reload();
        }, 2000);
      },
      error: (error) => {
        this.toast.displayMsg(`Error In ${actionConfig.errorText} Employee ${emp?.name}`);
      }
    });
  }
}
